import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTrashablePromises from "hooks/useTrashablePromises";
import { useIntl } from "react-intl";
import {
  IRegexValidation,
  IRegexValidationSaveRequest,
  RegexValidationSaveRequest,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import RegexValidationForm from "./RegexValidationForm";

type RegexValidationUpdateFormProps = {
  regexValidation: IRegexValidation;
  onUpdated: () => void;
  onCancel: () => void;
};

const RegexValidationUpdateForm = ({
  regexValidation,
  onUpdated,
  onCancel,
}: RegexValidationUpdateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { licenseService } = useGlobalContext();

  const onSubmit = (values: IRegexValidationSaveRequest) =>
    registerPromise(
      licenseService.saveRegexValidation(
        new RegexValidationSaveRequest({ ...values, id: regexValidation.id })
      )
    )
      .then(() => onUpdated())
      .catch((err: any) => ({ [FORM_ERROR]: translateError(err, t) }));

  return (
    <RegexValidationForm
      regexValidation={regexValidation}
      onSubmit={onSubmit}
      title={t({ id: "regexValidationUpdateTitle" })}
      submitLabel={t({ id: "saveButton" })}
      onCancel={onCancel}
    />
  );
};

export default RegexValidationUpdateForm;
